import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';

/**
 * 카운트다운 컴포넌트의 Props 인터페이스
 * @property {number} until - 카운트다운 목표 시간(분)
 * @property {number} [second] - 초기 초
 * @property {() => void} [onFinish] - 완료 시 호출 함수
 * @property {number | string | boolean} [reStart] - 재시작 트리거
 * @property {boolean} [stop] - 정지 여부
 * @property {React.CSSProperties} [style] - 스타일
 */
interface Props {
  until: number;
  second?: number;
  onFinish?: () => void;
  reStart?: number | string | boolean;
  stop?: boolean;
  style?: React.CSSProperties;
}

/**
 * 카운트다운 컴포넌트
 * 시간을 역순으로 카운트하는 컴포넌트입니다.
 * @param {Props} props - 카운트다운 컴포넌트의 props
 * @returns {JSX.Element} 카운트다운 컴포넌트
 */
export default function CountDown({
  until,
  second = 0,
  onFinish,
  reStart,
  stop,
  style,
}: Props) {
  const [minutes, setMinutes] = useState(until);
  const [seconds, setSeconds] = useState(second);

  useEffect(() => {
    setMinutes(until);
    setSeconds(second ? second : 0);
  }, [reStart, until]);

  useEffect(() => {
    const countdown = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(countdown);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    if (stop) {
      clearInterval(countdown);
      setMinutes(0);
      setSeconds(0);
    }
    if (minutes === 0 && seconds === 0 && onFinish && !stop) {
      onFinish();
    }
    return () => clearInterval(countdown);
  }, [minutes, seconds, onFinish, stop]);

  useEffect(() => {
    setMinutes(until);
    setSeconds(second ? second : 0);
  }, [reStart, until]);

  return (
    <Text style={style}>
      {minutes < 10 ? `0${minutes}` : minutes}:
      {seconds < 10 ? `0${seconds}` : seconds}
    </Text>
  );
}

const Text = styled.p`
  color: ${colors.primary};
  font-size: ${minmax(16)};
`;
